<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen';

export default {
	extends: Base,
  	data(){
	    return {
			Name:"BoTrxProject",
			mrClient:{},
			ClientContact:{},
			DocProductType:{},
			product_type:{},
			total_project:'',
			total_project_active:'',
			total_project_pending:'',
			total_project_inactive:'',
			total_project_range:'',
			detail:'',
			date_now:'',
			project_prospect:'',
			work_status:'',
			total_project_prospect:'',
			total_project_closing:'',
			total_project_rejected:'',
			row2: {contact_person:[]},
			MrSalutation: {},
			input_modal:{},
			detail_modal:{},
	    }
  	},
  	mounted(){
    	this.$set(this.$root, 'page', this)
		this.refreshData()
		$(document).on('hidden.bs.modal', '#addNewClient', ()=>{
		  	if(this.row.tp_client_id == '-1') this.$set(this.row, 'tp_client_id', '')
		  	this.row2 = {contact_person:[]}
		});
		$(document).on('hidden.bs.modal', '#addNewCP', ()=>{
		  	this.row.tp_cp_id.splice(this.row.tp_cp_id.indexOf("-1"),1)
		  	this.row2 = {contact_person:[]}
		});
		$(document).on('hidden.bs.modal', '#addNewProdType', ()=>{
		  	if(this.row.tp_prod_type == '-1') this.$set(this.row, 'tp_prod_type', '')
		  	this.row2 = {contact_person:[]}
		});
	},
	methods:{
		changePP: function(v){
			this.detail_modal = v
			$("#changePP").modal();
			setTimeout(()=>{
				this.$set(this.input_modal, 'tp_pp', v.tp_pp)
				this.$set(this.input_modal, 'project_id', v.tp_id)
			}, 500);
		},
		submitPP(e, callback){
			if(e&&e.btnLoading()) return;
        	BOGen.apirest("/"+this.Name,Object.assign({type:'editPP', id:this.input_modal.project_id}, this.input_modal),(err,resp)=>{
        		if(e) e.btnUnloading()
		        if(resp.error){
		          if(this.errorFormCallback) return this.errorFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "danger")
		        }
		        if(resp.success){
		          if(this.successFormCallback) return this.successFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "success", 500).then(()=>{
		          	$("#changePP").modal("hide");
		          	this.detail_modal.tp_pp = resp.statusPP
		          	if(resp.statusWorkStatus !== undefined){
		          		this.$set(this.detail_modal, 'trx_work_status', resp.statusWorkStatus);
		          		this.$set(this.detail_modal, 'tp_work_status', resp.statusWorkStatus);
		          	}
		          })
		        }
			},'POST')
		},
		changeWorkStatus: function(v){
			if(v.tp_pp !== 'C') {
				return Gen.infoModal("Work status hanya dapat diisi jika Follow-up Status Closing", "warning");
			}
			this.detail_modal = v
			$("#changeWorkStatus").modal();
			setTimeout(()=>{
				this.$set(this.input_modal, 'trx_work_status', v.trx_work_status || v.tp_work_status || '')
				this.$set(this.input_modal, 'project_id', v.id)
			}, 500);
		},
		submitWorkStatus(e, callback){
			if(e&&e.btnLoading()) return;
        	BOGen.apirest("/"+this.Name,Object.assign({type:'editWorkStatus', id:this.input_modal.project_id}, this.input_modal),(err,resp)=>{
        		if(e) e.btnUnloading()
		        if(resp.error){
		          if(this.errorFormCallback) return this.errorFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "danger")
		        }
		        if(resp.success){
		          if(this.successFormCallback) return this.successFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "success", 500).then(()=>{
		          	$("#changeWorkStatus").modal("hide");
		          	this.$set(this.detail_modal, 'trx_work_status', resp.statusWorkStatus);
		          	this.$set(this.detail_modal, 'tp_work_status', resp.statusWorkStatus);
		          })
		        }
			},'POST')
		},
		openDetail: function(v){
			$("#detailProject").modal();
			BOGen.apirest("/"+this.Name,{type:'detail', id:v.id},(e,resp)=>{
				if(e) return console.log(e);
				this.detail = resp;	
			},'POST')
        },
        addNewClient: function(e){
            if(e.val == -1){
            	$("#addNewClient").modal();
            }
        },
        submitClient(e, callback){
        	if(e&&e.btnLoading()) return;
        	BOGen.apirest("/"+this.Name,Object.assign({type:'addClient'}, this.row2),(err,resp)=>{
        		if(e) e.btnUnloading()
		        if(resp.error){
		          if(this.errorFormCallback) return this.errorFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "danger")
		        }
		        if(resp.success){
		          if(this.successFormCallback) return this.successFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "success", 1000).then(()=>{
		          	$("#addNewClient").modal("hide");
		          	this.mrClient.push(resp.newClient)
		          	this.$set(this.row, 'tp_client_id', resp.lastClient)
		          })
		        }
			},'POST')
        },
        addNewCP: function(e){
            if(e.val.indexOf('-1') > -1){
            	$("#addNewCP").modal();
            }
        },
        submitCP(e, callback){
        	if(e&&e.btnLoading()) return;
        	BOGen.apirest("/"+this.Name,Object.assign({type:'addCP', id:this.row.tp_client_id}, this.row2),(err,resp)=>{
        		if(e) e.btnUnloading()
		        if(resp.error){
		          if(this.errorFormCallback) return this.errorFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "danger")
		        }
		        if(resp.success){
		          if(this.successFormCallback) return this.successFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "success", 1000).then(()=>{
		          	$("#addNewCP").modal("hide");
		          	this.row.tp_cp_id.splice(this.row.tp_cp_id.indexOf("-1"),1)
		          	this.ClientContact.push(resp.newCP)
		          	this.row.tp_cp_id.push(resp.lastCP)
		          })
		        }
			},'POST')
        },
        addNewProdType: function(e){
            if(e.val == -1){
            	$("#addNewProdType").modal();
            }
        },
        submitProdType(e, callback){
        	if(e&&e.btnLoading()) return;
        	BOGen.apirest("/"+this.Name,Object.assign({type:'addProdType'}, this.row2),(err,resp)=>{
        		if(e) e.btnUnloading()
		        if(resp.error){
		          if(this.errorFormCallback) return this.errorFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "danger")
		        }
		        if(resp.success){
		          if(this.successFormCallback) return this.successFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "success", 1000).then(()=>{
		          	$("#addNewProdType").modal("hide");
		          	this.DocProductType.push(resp.newProdType)
		          	this.$set(this.row, 'tp_prod_type', resp.lastProdType)
		          })
		        }
			},'POST')
        },
	},
  	watch:{
	    '$route.query'(v){ this.refreshData() },
	    'filter.client'(v){ this.search() },
	    'filter.prodType'(v){ this.search() },
	    'filter.work_status'(v){ this.search() },
	    'row.tp_client_id':function(v){
	    	BOGen.apirest("/"+this.Name,Object.assign({type:'getCP', id:v}),(e,resp)=>{
				if(e) return console.log(v);
				this.ClientContact = resp;
				if(this.row.tp_cp_id) this.$set(this.row, "tp_cp_id", this.row.tp_cp_id)
			},'POST')
	    },
	    'row.tp_pp': function(v){
	    	if(v !== 'C') {
	    		this.$set(this.row, 'tp_work_status', '')
	    	}
	    },
  	}
}
</script>

<template>
	<div class="container-fluid">
		<PageTitle></PageTitle>
		
		<!-- ======================================================================== 
			LIST DATA
		============================================================================= -->
		<div class="panel panel-flat" v-if="!$route.params.id">
			<div class="panel-body panel-filter">
				<VForm @resp="search" id="form_budget">
					<div class="row">
						<div class="col-sm-3">
							<h3 class="box-title">{{ObjectName}} List 
								<!-- <span v-if="data.total">({{(data.total||0).format()}})</span> -->
							</h3>
						</div>
						<div class="col-sm-9"></div>
					</div>
					<div class="row">
						<div class="col-sm-3">
							<div class="input-group">
								<div class="input-group-addon"><span class="ti-calendar"></span></div>
		                      	<DateRangePicker v-model="filter.rangeDate" placeholder="Range Date"></DateRangePicker>
		                    </div>	
						</div>
						<div class="col-sm-2">
							<select2 :options="mrClient" :object="['mc_id','mc_name']" v-model="filter.client" class="form-control">
								<option value="">Client</option>
							</select2>
						</div>
						<div class="col-sm-2">
							<select2 :options="DocProductType" :object="['mpt_id','mdpt_name']" v-model="filter.prodType" class="form-control">
								<option value="">Product Type</option>
							</select2>
						</div>
						<div class="col-sm-2">
							<select2 :options="work_status" v-model="filter.work_status" class="form-control">
								<option value="">Work Status</option>
							</select2>
						</div>
						<div class="col-sm-2">
							<div class="has-feedback has-feedback-left">
								<input type="search" v-model="filter.search" class="form-control" placeholder="Type and hit Enter">
								<div class="form-control-feedback">
									<i class="icon-search4 text-size-base text-muted"></i>
								</div>
							</div>
						</div>
						<div class="col-sm-1">
							<router-link :to="{name:Name}" class="btn btn-warning">Reset</router-link>
						</div>
					</div>
				</VForm>
			</div>
			<div class="panel-body">
				<div class="row">
			        <div class="col-md-3">
			        	<div class="panel_box_project table-responsive">
			                <h3><strong>Total Project</strong>
			                	<span v-if="filter.rangeDate">|<strong>{{ total_project_range }}</strong></span>
			                	<span>{{ total_project }}</span>
			                </h3>
			            </div>
			        </div>
			        <!-- <div class="col-md-3">
			        	<div class="panel_box_project table-responsive">
			                <h3><strong>Active</strong>
			                	<span>{{ total_project_active }}</span>
			                </h3>
			            </div>
			        </div>
			        <div class="col-md-3">
			        	<div class="panel_box_project table-responsive">
			                <h3><strong>Pending</strong>
			                	<span>{{ total_project_pending }}</span>
			                </h3>
			            </div>
			        </div>
			        <div class="col-md-3">
			        	<div class="panel_box_project table-responsive">
			                <h3><strong>Inactive</strong>
			                	<span>{{ total_project_inactive }}</span>
			                </h3>
			            </div>
			        </div> -->
			        <div class="col-md-3">
			        	<div class="panel_box_project table-responsive">
			                <h3><strong>Prospect</strong>
			                	<span>{{ total_project_prospect }}</span>
			                </h3>
			            </div>
			        </div>
			        <div class="col-md-3">
			        	<div class="panel_box_project table-responsive">
			                <h3><strong>Closing</strong>
			                	<span>{{ total_project_closing }}</span>
			                </h3>
			            </div>
			        </div>
			        <div class="col-md-3">
			        	<div class="panel_box_project table-responsive">
			                <h3><strong>Rejected</strong>
			                	<span>{{ total_project_rejected }}</span>
			                </h3>
			            </div>
			        </div>
			        <div class="col-md-3" v-for="(v1,k1) in product_type" :key="k1">
			        	<div class="panel_box_project table-responsive">
			                <h3><strong>{{ v1.mdpt_initial }}</strong>
			                	<span>{{ v1.total }}</span>
			                </h3>
			            </div>
			        </div>
			    </div>
			</div>
			<div class="table-responsive ajax-table">
				<table class="table table-hover table-bordered">
					<thead>
						<tr>
							<th>#</th>
							<th>{{ fields.tp_client_id }}</th>
							<th>{{ fields.tp_name }}</th>
							<th>{{ fields.tp_number }}</th>
							<th>PIC</th>
							<th>Follow-up Status</th>
							<th>Work Status</th>
							<th>{{ fields.tp_create_date }}</th>
							<th width="120px">Action</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(v,k) in data.data" :key="k">
							<td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
							<td>
								{{v.client}}<br>
								<span class="label label-sm no_radius" :style="'background:#'+v.color_initial_client">{{ v.initial_client }}</span>
							</td>
							<td>
								{{v.tp_name}}
								<br><span class="label label-sm no_radius" :style="'background:#'+v.color_initial">{{ v.tp_initial }}</span><br>
								<small>{{v.project}}</small>
							</td>
							<td>
								<a class="btn_copy" v-clipboard:copy="v.tp_number" v-tooltip="'Copy Project ID'">
									{{ v.tp_number }}
								</a>
							</td>
							<td>
								<a class="btn_copy" v-clipboard:copy="v.copy_person" v-tooltip="'Copy Data'">
									<span class="label label-sm no_radius btn-warning" v-for="(v2,k2) in v.person_incharge">
										{{ v2.mcc_name }}{{ v2.position }}
									</span>
								</a>
							</td>
							<td>
								<a href="javascript:;" @click="changePP(v)">
									<StatusLabel :status="v.tp_pp" type="project-prospect" style="cursor: pointer;"></StatusLabel>
								</a>
							</td>
							<td>
								<a href="javascript:;" @click="changeWorkStatus(v)" v-if="v.tp_pp == 'C' && (v.trx_work_status || v.tp_work_status)">
									<StatusLabel :status="v.trx_work_status || v.tp_work_status" type="work-status" style="cursor: pointer;"></StatusLabel>
								</a>
								<a href="javascript:;" @click="changeWorkStatus(v)" v-else-if="v.tp_pp == 'C'">
									<span class="label label-default" style="cursor: pointer;">-- Set Status --</span>
								</a>
								<span v-else class="text-muted">-</span>
							</td>
							<td>{{v.create_date}}</td>
							<td class="btn-action text-center">
								<a href="javascript:;" class="icon_action" @click="openDetail(v)" v-tooltip="'View Detail'"><i class="fa fa-eye"></i></a>

								<router-link class="icon_action" :to="{name:Name,params:{id:v.id}}" v-tooltip="'Edit'"><i class="icon-pencil"></i></router-link>

								<a v-if="v.count_relation==0" href="javascript:;" class="icon_action" @click="deleteItem($event,k)" v-tooltip="'Remove'"><i class="icon-trash"></i></a>
								<a v-if="v.count_relation>0" href="javascript:;" class="icon_action" @click="relatedDeleteItem($event,k)" v-tooltip="'Remove'"><i class="icon-trash"></i></a>
							</td>
						</tr>
						<tr v-if="NotFound">
							<td colspan="99">
								<h3 class="tc">{{NotFound}}</h3>
							</td>
						</tr>
						<tr v-if="data.data===false">
							<td colspan="99">
								<LoadingSpinner light></LoadingSpinner>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="panel-body">
				<div class="pull-right">
					<Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
				</div>
			</div>
		</div>

		<!-- Modal -->
		<VModal name="changePP" title="Change Project/Prospect" sizeModal="modal-md" method="post" noFooter @resp="submitPP">
			<div class="infoModal"></div>
			<div class="row">
				<div class="col-sm-6">
					<label class="">Status <span class="text-danger">*</span></label>
				</div>
				<div class="col-sm-6">
					<input type="hidden" v-model="input_modal.project_id">
					<select2 name="tp_pp" v-bind="validation('tp_pp')" :options="project_prospect" v-model="input_modal.tp_pp" class="form-control">
						<option value="">-- Select Status --</option>
					</select2>
				</div>
			</div>
			<div class="modal-footer" style="margin-top: 10px;">
				<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
				<button type="submit" class="btn btn-primary btn-loading">Submit</button>
			</div>
		</VModal>
		<VModal name="changeWorkStatus" title="Change Work Status" sizeModal="modal-md" method="post" noFooter @resp="submitWorkStatus">
			<div class="infoModal"></div>
			<div class="row">
				<div class="col-sm-6">
					<label class="">Work Status <span class="text-danger">*</span></label>
				</div>
				<div class="col-sm-6">
					<input type="hidden" v-model="input_modal.project_id">
					<select2 name="trx_work_status" :options="work_status" v-model="input_modal.trx_work_status" class="form-control">
						<option value="">-- Select Status --</option>
					</select2>
				</div>
			</div>
			<div class="modal-footer" style="margin-top: 10px;">
				<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
				<button type="submit" class="btn btn-primary btn-loading">Submit</button>
			</div>
		</VModal>
		<VModal name="addNewClient" title="Add Client" method="post" noFooter @resp="submitClient">
			<div class="infoModal"></div>
			<div class="row">
				<div class="col-sm-6">
					<BoField name="mc_name" v-model="row2.mc_name" mandatory :attr="{required:true}"></BoField>
					<BoField name="mc_initial" v-model="row2.mc_initial" mandatory :attr="{class:'input_capitalize', required:true}"></BoField>
					<BoField name="mc_join_date">
						<div class="input-group">
	                      	<DatePicker name="mc_join_date" v-model="row2.mc_join_date" v-bind="validation('mc_join_date')"></DatePicker>
	                      	<div class="input-group-addon"><span class="ti-calendar"></span></div>
	                    </div>
					</BoField>
					<BoField name="mc_comp_address">
						<textarea name="mc_comp_address" rows="4" class="form-control" v-model="row2.mc_comp_address" v-bind="validation('mc_comp_address')"></textarea>
					</BoField>
				</div>
				<div class="col-sm-6">
					<BoField name="mc_comp_name" v-model="row2.mc_comp_name" mandatory :attr="{required:true}"></BoField>
					<BoField name="mc_phone" v-model="row2.mc_phone" mandatory :attr="{required:true}"></BoField>
					<BoField name="mc_url" v-model="row2.mc_url"></BoField>
					<BoField name="mc_is_active" mandatory>
						<div class="radio-group">
							<radio name="mc_is_active" v-model="row2.mc_is_active" option="Y" :attr="validation('mc_is_active')">Active</radio>
							<radio name="mc_is_active" v-model="row2.mc_is_active" option="N">Inactive</radio>
						</div>
					</BoField>
				</div>
				<div class="col-sm-12">
					<h3>Contact Person</h3>
					<table class="table table-bordered">
						<thead>
							<tr>
								<th colspan="10" class="text-right" style="border: 1px solid transparent;">
									<button type="button" class="btn btn-primary" @click="row2.contact_person.push({})">Add Contact Person</button>
								</th>
							</tr>
							<tr>
								<th class="lbl_popup">Salutation <span class="text-danger">*</span></th>
								<th class="lbl_popup">Fullname <span class="text-danger">*</span></th>
								<th class="lbl_popup">Email</th>
								<th class="lbl_popup">Phone Number</th>
								<th class="lbl_popup">Position</th>
								<th class="lbl_popup" v-if="row2.contact_person.length>1"></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(v3,k3) in row2.contact_person">
								<td>
									<select2 :options="MrSalutation" v-model="v3.mcc_salutation" class="form-control">
										<option value="">Salutation</option>
									</select2>
								</td>
								<td>
									<input type="text" v-model="v3.mcc_name" class="form-control" required="">
								</td>
								<td>
									<input type="email" v-model="v3.mcc_email" class="form-control">
								</td>
								<td>
									<input type="text" v-model="v3.mcc_phone" class="form-control">
								</td>
								<td>
									<input type="text" v-model="v3.mcc_position" class="form-control">
								</td>
								<td v-if="row2.contact_person.length>1">
									<button type="button" class="btn btn-danger" @click="row2.contact_person.length>1 ? row2.contact_person.splice(k3,1) : ''"><i class="icon-trash"></i></button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
				<button type="submit" class="btn btn-primary btn-loading">Submit</button>
			</div>
		</VModal>
		<VModal name="addNewCP" title="Add Contact Person" method="post" noFooter @resp="submitCP">
			<div class="infoModal"></div>
			<div class="row">
				<div class="col-sm-12" style="margin-bottom: 25px;">
					<label class="">Salutation <span class="text-danger">*</span></label>
					<select2 :options="MrSalutation" name="mcc_salutation" v-model="row2.mcc_salutation" :attr="{required:true}" class="form-control">
						<option value="">Salutation</option>
						option
					</select2>
				</div>
				<div class="col-sm-6">
					<BoField name="mcc_name" v-model="row2.mcc_name" mandatory :attr="{required:true}"></BoField>
					<BoField name="mcc_position" v-model="row2.mcc_position"></BoField>
				</div>
				<div class="col-sm-6">
					<BoField name="mcc_email" v-model="row2.mcc_email"></BoField>
					<BoField name="mcc_phone" v-model="row2.mcc_phone"></BoField>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
				<button type="submit" class="btn btn-primary btn-loading">Submit</button>
			</div>
		</VModal>
		<VModal name="addNewProdType" title="Add Product Type" method="post" noFooter @resp="submitProdType">
			<div class="infoModal"></div>
			<div class="row">
				<div class="col-sm-6">
					<BoField name="mdpt_name" v-model="row2.mdpt_name" mandatory :attr="{required:true}"></BoField>
					<BoField name="mdpt_desc">
						<textarea name="mdpt_desc" rows="4" class="form-control" v-model="row2.mdpt_desc" v-bind="validation('mdpt_desc')"></textarea>
					</BoField>
				</div>
				<div class="col-sm-6">
					<BoField name="mdpt_initial" v-model="row2.mdpt_initial" mandatory :attr="{class:'input_capitalize', required:true}"></BoField>
					<BoField name="mdpt_is_active">
						<div class="radio-group">
							<radio name="mdpt_is_active" v-model="row2.mdpt_is_active" option="Y" :attr="validation('mdpt_is_active')">Active</radio>
							<radio name="mdpt_is_active" v-model="row2.mdpt_is_active" option="N">Inactive</radio>
						</div>
					</BoField>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
				<button type="submit" class="btn btn-primary btn-loading">Submit</button>
			</div>
		</VModal>

		<VModal name="detailProject" title="Detail Project" method="post" noFooter>
			<table class="table">
				<tbody>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Client</h4>
								<p>
									{{ detail.client }}
									<span class="label label-sm no_radius" :style="'background:#'+detail.client_initial_color">{{ detail.client_initial }}</span>
								</p>
							</div>
						</td>
						<td>
							<div class="detail_report">
								<h4>Contact Person</h4>
								<p v-for="(v1,k1) in detail.client_contact">
									Nama: {{ v1.nama }}<br>
									Position: {{ v1.position }}<br>
									Email: {{ v1.email }}<br>
									HP: {{ v1.phone }}
								</p>
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Project Name</h4>
								<p>{{ detail.tp_name }}</p>
							</div>
						</td>
						<td>
							<div class="detail_report">
								<h4>Project Type</h4>
								<p>
									<span class="label label-sm no_radius" :style="'background:#'+detail.project_type_color">{{ detail.project_type }}</span>
								</p>
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Description</h4>
								<p>{{ detail.tp_desc ? detail.tp_desc : '-' }}</p>
							</div>							
						</td>
						<td>
							<div class="detail_report">
								<h4>Create Date</h4>
								<p>{{ detail.create_date }}</p>
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Follow-up Status</h4>
								<p>
									<StatusLabel :status="detail.tp_pp" type="project-prospect"></StatusLabel>
								</p>
							</div>
						</td>
						<td>
							<div class="detail_report">
								<h4>Work Status</h4>
								<p>
									<StatusLabel :status="detail.trx_work_status || detail.tp_work_status" type="work-status" v-if="detail.tp_pp == 'C' && (detail.trx_work_status || detail.tp_work_status)"></StatusLabel>
									<span v-else class="text-muted">-</span>
								</p>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</VModal>

		<!-- ======================================================================== 
			FORM CRUD	
		============================================================================= -->
		<div class="panel panel-flat" v-if="$route.params.id">
			<VForm @resp="submitForm" method="post">
				<div class="panel-heading">
					<h2 class="panel-title">{{(row.id?"Edit":"Add")+" "+ObjectName}}</h2>
				</div>	
				<div class="panel-body">
					<div class="info"></div>
					<div class="row">
						<div class="col-sm-6">
							<BoField name="tp_client_id" v-model="row.tp_client_id">
								<select2 name="tp_client_id" v-bind="validation('tp_client_id')" :options="mrClient" :object="['mc_id','mc_name']" v-model="row.tp_client_id" @change="addNewClient($event)" class="form-control">
									<option value="">-- Select Client --</option>
								</select2>
							</BoField>
							<BoField name="tp_name" v-model="row.tp_name"></BoField>
							<BoField name="tp_desc">
								<textarea name="tp_desc" rows="4" class="form-control" v-model="row.tp_desc" v-bind="validation('tp_desc')"></textarea>
							</BoField>
							<BoField name="tp_work_status" v-model="row.tp_work_status" v-if="row.tp_pp == 'C'" mandatory>
								<select2 name="tp_work_status" v-bind="validation('tp_work_status')" :options="work_status" v-model="row.tp_work_status" class="form-control" :attr="{required: row.tp_pp == 'C'}">
									<option value="">-- Select Status --</option>
								</select2>
							</BoField>
							<BoField name="tp_create_date">
								<div class="input-group">
			                      	<DatePicker name="tp_create_date" v-model="row.tp_create_date" v-bind="validation('tp_create_date')" :value="date_now"></DatePicker>
			                      	<div class="input-group-addon"><span class="ti-calendar"></span></div>
			                    </div>
							</BoField>
														
						</div>
						<div class="col-sm-6">
							<BoField name="tp_cp_id">
								<select2 name="tp_cp_id" v-bind="validation('tp_cp_id')" :options="ClientContact" :object="['mcc_id','mcc_name']" v-model="row.tp_cp_id" class="form-control" multiple @change="addNewCP($event)">
								</select2>
							</BoField>
							<BoField name="tp_initial" v-model="row.tp_initial" :attr="{class:'input_capitalize'}"></BoField>
							<BoField name="tp_prod_type">
								<select2 name="tp_prod_type" v-bind="validation('tp_prod_type')" :options="DocProductType" :object="['mpt_id','mdpt_name']" v-model="row.tp_prod_type" @change="addNewProdType($event)" class="form-control">
									<option value="">-- Select Type --</option>
								</select2>
							</BoField>
							<BoField name="tp_pp" v-model="row.tp_pp">
								<select2 name="tp_pp" v-bind="validation('tp_pp')" :options="project_prospect" v-model="row.tp_pp" class="form-control">
									<option value="">-- Select Status --</option>
								</select2>
							</BoField>
							<BoField name="tp_is_active">
								<div class="radio-group">
									<radio name="tp_is_active" v-model="row.tp_is_active" option="Y" :attr="validation('tp_is_active')">Active</radio>
									<radio name="tp_is_active" v-model="row.tp_is_active" option="N">Inactive</radio>
									<radio name="tp_is_active" v-model="row.tp_is_active" option="P">Pending</radio>
								</div>
							</BoField>							
						</div>
						<div class="col-xs-12">
							<div class="text-right">
								<button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading">Submit form <i class="icon-arrow-right14 position-right"></i></button>
							</div>
						</div>
					</div>
				</div>
			</VForm>
		</div>
	</div>
</template>
